import { createReducer, on } from '@ngrx/store';
import { dismissInfoPanel } from './ui.action';

export interface UiState {
  dismissedPanels: Record<string, boolean>;
}

export const initialState: UiState = {
  dismissedPanels: {},
};

export const uiReducer = createReducer(
  initialState,
  on(dismissInfoPanel, (state, { panelId }) => ({
    ...state,
    dismissedPanels: {
      ...state.dismissedPanels,
      [panelId]: true,
    },
  }))
);
